export default __webpack_public_path__ + "static/media/camdad.08d92895.png";